// ChatWebUI.tsx
import React from 'react'
import { Bot } from 'lucide-react'
import { ChatContainer, ChatButton } from './ChatWebUI.styles'
import { Tooltip } from '@enterprise-ui/canvas-ui-react'

interface AgentBubbleProps {
  businessId: string
  chatBotBaseUrl: string | undefined
}

const ChatWebUI: React.FC<AgentBubbleProps> = ({
  businessId,
  chatBotBaseUrl,
}) => {
  const handleClick = () => {
    if (chatBotBaseUrl) {
      window.open(`${chatBotBaseUrl}/${businessId}`, '_blank')
    }
  }

  return (
    <ChatContainer className="hc-mr-dense">
      <Tooltip location="top" content="AI Assistant">
        <ChatButton onClick={handleClick}>
          <Bot size={20} />
        </ChatButton>
      </Tooltip>
    </ChatContainer>
  )
}

export default ChatWebUI
